module.exports = __webpack_public_path__ + "img/img-c7fdbdce.cf7e3737.png";